module.exports = __webpack_public_path__ + "frontend/images/homepage/slider/card@2.jpg?27b4321673069af74504c2f36990de71";